import { render, staticRenderFns } from "./ContentBottom.vue?vue&type=template&id=0147e1a8&"
import script from "./ContentBottom.vue?vue&type=script&lang=ts&"
export * from "./ContentBottom.vue?vue&type=script&lang=ts&"
import style0 from "./ContentBottom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports